export const approvalHierarchyFlow = [
  {
    _id: "rm",
    status: "rm approval",
    next_stage: "Awaiting Data Entry Maker approval",
    show: `selectedData?.subworkFlowInfo?.active_step == 1 && current_user == 'rm'`,
    approval_flow: {
      form_elements: [
        {
          type: "subheader",
          sublabel: "Upload Documents",
        },

        {
          type: "upload",

          id: "upload_RM_note",
          name: "upload_RM_note",

          label: "Upload RM Note",

          size: "col-12",

          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",
          id: "upload_FME",
          label: "Upload FME",
          size: "col-12",
          name: "upload_FME",
          enum: {
            "application/pdf": [],
            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",

          id: "upload_client_risk_profiling",

          label: "Upload client risk profiling",

          size: "col-12",

          name: "upload_client_risk_profiling",

          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",

          id: "upload_rm_checklist",

          label: "Upload RM checklist",

          size: "col-12",

          name: "upload_rm_checklist",

          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",

          id: "upload_net_asset_workbook",

          label: "Upload net asset workbook",

          size: "col-12",

          name: "upload_net_asset_workbook",
          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",

          id: "upload_RA_toolkit",

          label: "Upload RA toolkit",

          size: "col-12",

          name: "upload_RA_toolkit",

          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",

          id: "upload_google_search",

          label: "Upload google search",

          size: "col-12",

          name: "upload_google_search",

          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },

        {
          type: "upload",

          id: "upload_others",

          label: "Upload others",

          size: "col-12",

          name: "upload_others",

          tooltip: [],

          enum: {
            "application/pdf": [],

            "image/jpeg": [],
          },

          validators: {
            required: true,

            pattern: [],

            min_length: "",

            max_length: "",
          },

          error_messages: {
            min_error: "",

            max_error: "",

            pattern_error: "Invalid File",

            required_error: "Required",
          },
        },
      ],
      form_buttons: [
        {
          label: "Back",
          action: "back",
        },
        {
          label: "Submit",
          action: "next",
          disabled: `!(selectedData?.upload_RM_note?.originalname && selectedData?.upload_FME?.originalname && selectedData?.upload_client_risk_profiling?.originalname && selectedData?.upload_rm_checklist?.originalname && selectedData?.upload_net_asset_workbook?.originalname && selectedData?.upload_RA_toolkit?.originalname && selectedData?.upload_google_search?.originalname && selectedData?.upload_others?.originalname)`,
        },
      ],
    },
    reject_flow: {
      form_elements: [
        {
          type: "subheader",
          name: "rejection_remarks_subHeader",
          sublabel: "Remarks",
        },
        {
          type: "textarea",
          id: "rejection_remarks",
          label: "Remarks",
          label_style: "mt-1",
          size: "col-12",
          rows: 4,
          name: "rejection_remarks",
          placeholder: "Enter Remarks",
          validators: {
            required: false,
            pattern: [],
            min_length: "",
            max_length: "",
          },
          error_messages: {
            min_error: "",
            max_error: "",
            pattern_error: "",
            required_error: "Required",
          },
        },
      ],
      form_buttons: [
        {
          label: "Submit",
          action: "reject",
          disabled: `selectedData?.rejection_remarks == ""`
        },
      ],
    },
    form_buttons: [
      {
        label: "Reject",
        className: "reject_button me-3 px-4",
        type: "button",
        action: "reject",
        variant: "outline-danger",
        show: `selectedData?.currentUserRole?.reject == true`,
      },
      {
        label: "Accept",
        className: "accept_button me-3 px-4",
        type: "button",
        action: "approve",
        show: `selectedData?.currentUserRole?.approve == true`,
      },
    ]
  },
  {
    _id: 2,
    status: "Branch Ops approve",
    next_stage: "Awaiting Compliance Officer/MLRO approval",
    show: `selectedData?.subworkFlowInfo?.active_step == 2 && current_user == 'branch ops'`,
    form_elements: [
      {
        type: "subheader",
        sublabel: "Negative Media Search",
      },
      {
        type: "radio",
        id: "enter_name",
        label: "Negative media search result.",
        size: "col-6",
        name: "enter_name",
        placeholder: "Eg: Victor Kart",
        options: [
          {
            label: "Found",
            id: "option1",
            for: "option1",
          },
          {
            label: "Not Found",
            id: "option2",
            for: "option2",
          },
        ],
        validators: {
          required: true,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
      {
        type: "upload",
        id: "national_id_doc",
        label: "Upload results screenshot for negative media search",
        size: "col-12",
        name: "national_id_doc",
        show: 'selectedData.enter_name == "Found"',
        tooltip: [
          {
            alert_type: "primary",
            tooltip_text:
              "Upload emirates ID to confirm the details entered is correct or incorrect to avoid any data changes in future",
            trigger: "?",
          },
        ],
        enum: {
          "application/pdf": [],
          "image/jpeg": [],
        },
        validators: {
          required: true,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "Invalid File",
          required_error: "Required",
        },
      },
    ],
    form_buttons: [
      {
        label: "Back",
        action: "back",
      },
      {
        label: "Proceed",
        action: "next",
      },
    ],
  },
  {
    _id: 3,
    status: "Branch Ops approve",
    next_stage: "Awaiting Compliance Officer/MLRO approval",
    form_elements: [
      {
        type: "subheader",
        sublabel: "Negative Media Search",
      },
      {
        type: "textarea",
        id: "remarks",
        label: "Remarks",
        size: "col-12",
        name: "remarks",
        placeholder: "Enter Remarks",
        validators: {
          required: false,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
    ],

    form_buttons: [
      {
        label: "Back",
        action: "back",
      },
      {
        label: "Proceed",
        action: "next",
        //  "disabled": "popupreducer?.popupData?.enter_name== undefined",
      },
    ],
  },
  {
    _id: 3,
    status: "Compliance Officer/MLRO approved",
    next_stage: "Awaiting Branch Head approval",
    form_elements: [
      {
        type: "subheader",
        sublabel: "AML Risk Category",
      },
      {
        type: "dropdown",
        id: "risk_category",
        label: "AML Risk Category",
        size: "col-12",
        name: "risk_category",
        placeholder: "Eg:High",
        options: [
          {
            label: "Select",
            value: "Select",
          },
          {
            label: "High",
            value: "High",
          },
          {
            label: "Low",
            value: "Low",
          },
        ],
        validators: {
          required: true,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
      {
        type: "textarea",
        id: "remarks",
        label: "Remarks",
        size: "col-12",
        name: "remarks",
        placeholder: "Enter Remarks",
        validators: {
          required: false,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
      {
        type: "upload",
        id: "national_id_doc",
        label: "Upload supporting documents",
        size: "col-12",
        name: "national_id_doc",

        tooltip: [],
        enum: {
          "application/pdf": [],
          "image/jpeg": [],
        },
        validators: {
          required: true,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "Invalid File",
          required_error: "Required",
        },
      },

      {
        type: "note",
        id: "AML _Risk_Category_Low",
        label: "Updated change will appear only after Bank Head approval",
        size: "col-12",
        name: "AML _Risk_Category_Low",
        //   show: 'selectedData.risk_category== "Low"',
        tooltip: [{}],
      },
    ],

    form_buttons: [
      {
        label: "Back",
        action: "back",
      },
      {
        label: "Proceed",
        action: "next",
        show: 'popupreducer?.popupData?.risk_category == "Select" ',
        // disabled:
        //   'popupreducer?.popupData?.risk_category == "Select"',
      },
      {
        label: "Submit",
        action: "next",
        show: 'approvalHierarchyFlow?.approval_flow?.popupData?.risk_category == "High"',
      },
      {
        label: "Update",
        action: "next",
        show: 'approvalHierarchyFlow?.approval_flow?.popupData?.risk_category == "Low"',
      },
    ],
  },
  {
    _id: 4,
    status: "Branch Head approved",
    next_stage: "Awaiting DVU approval",
    form_elements: [
      {
        type: "subheader",
        sublabel: "AML Risk Category",
      },
      {
        type: "dropdown",
        id: "risk_category",
        label: "AML Risk Category",
        size: "col-12",
        name: "risk_category",
        placeholder: "Eg:High",
        options: [
          {
            label: "Select",
            value: "Select",
          },
          {
            label: "High",
            value: "High",
          },
          {
            label: "Low",
            value: "Low",
          },
        ],
        validators: {
          required: true,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
      {
        type: "textarea",
        id: "remarks",
        label: "Remarks",
        size: "col-12",
        name: "remarks",
        placeholder: "Enter Remarks",
        validators: {
          required: false,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
      {
        type: "upload",
        id: "national_id_doc",
        label: "Upload supporting documents",
        size: "col-12",
        name: "national_id_doc",

        tooltip: [],
        enum: {
          "application/pdf": [],
          "image/jpeg": [],
        },
        validators: {
          required: true,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "Invalid File",
          required_error: "Required",
        },
      },
      {
        type: "label",
        id: "AML _Risk_Category_Low",
        label: "Updated change will appear only after Bank Head approval",
        size: "col-12",
        name: "AML _Risk_Category_Low",
        //   show: 'selectedData.risk_category== "Low"',
        tooltip: [{}],
      },
    ],

    form_buttons: [
      {
        label: "Back",
        action: "back",
      },
      {
        label: "Proceed",
        action: "next",
        //   show: 'conditionalRendering?.popupData?.risk_category == "Select" ',
        //   disabled:
        //     'conditionalRendering?.popupData?.risk_category == "Select"',
      },
      {
        label: "Submit",
        action: "next",
        // show: 'conditionalRendering?.popupData?.risk_category == "High"',
      },
      {
        label: "Update",
        action: "next",
        //   show: 'conditionalRendering?.popupData?.risk_category == "Low"',
      },
    ],
  },
  {
    _id: 6,
    status: "Data Entry Maker approved",
    next_stage: "Awaiting Data Entry Checker approval",

    form_elements: [
      {
        type: "subheader",
        sublabel: "Add CRN and current account number",
      },

      {
        type: "text",
        id: "crn",
        label: "CRN",
        size: "col-12",
        name: "crn",
        placeholder: "Eg: 1452-6545-7654-2",
        validators: {
          required: false,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
      {
        type: "text",
        id: "crn",
        label: "Current account number",
        size: "col-12",
        name: "crn",
        placeholder: "Eg: 1452-6545-7654-2",
        validators: {
          required: false,
          pattern: [],
          min_length: "",
          max_length: "",
        },
        error_messages: {
          min_error: "",
          max_error: "",
          pattern_error: "",
          required_error: "Required",
        },
      },
    ],

    form_buttons: [
      {
        label: "Back",
        action: "back",
      },
      {
        label: "Add ",
        action: "add",
      },
    ],
  },
  {
    _id: 8,
    status: "Data Entry Checker approved",
    next_stage: "Awaiting Quality checker approval",

    form_elements: [
      {
        type: "subheader",

        sublabel: "Upload Documents",
      },

      {
        type: "upload",

        id: "upload_RM_note",

        label: "Upload RM Note",

        size: "col-12",

        name: "upload_RM_note",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_FME",

        label: "Upload FME",

        size: "col-12",

        name: "upload_FME",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_client_risk_profiling",

        label: "Upload client risk profiling",

        size: "col-12",

        name: "upload_client_risk_profiling",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_rm_checklist",

        label: "Upload RM checklist",

        size: "col-12",

        name: "upload_rm_checklist",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_net_asset_workbook",

        label: "Upload net asset workbook",

        size: "col-12",

        name: "upload_net_asset_workbook",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_RA_toolkit",

        label: "Upload RA toolkit",

        size: "col-12",

        name: "upload_RA_toolkit",

        tooltip: [],

        enum: { max_length: "" },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_RA_toolkit",

        label: "Upload RA toolkit",

        size: "col-12",

        name: "upload_RA_toolkit",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],
          "application/pdf": [],

          "image/jpeg": [],
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_google_search",

        label: "Upload google search",

        size: "col-12",

        name: "upload_google_search",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },

      {
        type: "upload",

        id: "upload_others",

        label: "Upload others",

        size: "col-12",

        name: "upload_others",

        tooltip: [],

        enum: {
          "application/pdf": [],

          "image/jpeg": [],
        },

        validators: {
          required: true,

          pattern: [],

          min_length: "",

          max_length: "",
        },

        error_messages: {
          min_error: "",

          max_error: "",

          pattern_error: "Invalid File",

          required_error: "Required",
        },
      },
    ],

    form_buttons: [
      {
        label: "Back",

        action: "back",
      },

      {
        label: "Submit",

        action: "next",
      },
    ],
  },
  
];
